import fetchClient from "./fetchClient";

export async function getCategoryTree(queryParams) {
    // получение дерева категорий
    return await fetchClient('/categories/categories_tree',{queryParams})
}

export async function searchServices(queryParams) {
    /**поиск услуг по названию, в категории
    *  queryParams = {
    *    search: 'мрт головы',
    *    category_id: 12,
    *    page: 1,
    *  }
    **/

    return await fetchClient('/services/search',{queryParams})
}

export async function getAvailableServices(queryParams) {
    /**поиск услуг по названию, в категории
     *  queryParams = {
     *    category_id: 12,
     *    page: 1,
     *  }
     **/

    return await fetchClient('/services/available_services',{queryParams})
}
